<div class="page-body" *ngIf="loading">
  <app-spinner></app-spinner>
</div>

<div class="banner" *ngIf="backNavigationAllowed()">
  <img src="assets/icon/Arrow-Left.svg" alt="" class="back-button" (click)="reroute()"/>
</div>

<div class="page-body" *ngIf="!loading">
  <div class="contents-wrapper">
    <div class="contents-container">
      <h1 class="heading">Kontaktuppgifter</h1>
      <p class="info-text confirm-email-text">
        Vänligen ange din e-postadress och mobilnummer.
      </p>
      <form [formGroup]="form" id="email-and-phone-form">
        <div class="input-container">
          <zaver-animated-form-input
            [size]="'large'"
            [placeholder]="'E-postadress'"
            [formControlName]="'email'"
            [error]="form.controls.email.invalid && showError"
            [errorMessage]="'Vänligen ange en giltig e-postadress'"
            [inputMode]="'email'"
            [autoComplete]="'email'"
            [inputType]="'email'"
            [errorIcon]="'assets/icon/icon_error.svg'"
          ></zaver-animated-form-input>
        </div>

        <div class="input-container">
          <zaver-animated-form-input
            [size]="'large'"
            [placeholder]="'Mobilnummer'"
            [formControlName]="'phoneNumber'"
            [error]="form.controls.phoneNumber.invalid && showError"
            [errorMessage]="
              'Vänligen ange ett giltigt mobilnummer (07******** eller +46*********)'
            "
            [inputMode]="'tel'"
            [autoComplete]="'tel'"
            [inputType]="'tel'"
            [errorIcon]="'assets/icon/icon_error.svg'"
          ></zaver-animated-form-input>
        </div>
      </form>

      <app-general-error
        style="margin-top: 8px"
        *ngIf="form.valid && noResponseError"
      ></app-general-error>

      <div class="footer-wrapper">
        <div class="footer-container">
          <div class="total-amount" *ngIf="state.totalCheckoutValue">
            <p>Orderbelopp: {{ state.totalCheckoutValue | value }}</p>
            <p>
              <zaver-button-link text="Visa detaljer" (click)="showPurchaseDetails()"></zaver-button-link>
            </p>
          </div>

          <div class="button-container">
            <zaver-primary-button
              [buttonType]="'submit'"
              [formId]="'email-and-phone-form'"
              [text]="'Nästa'"
              (click)="handleCtaClick()"
            ></zaver-primary-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<zaver-checkout-modal *ngIf="selectorItems && modalActive" [buttonText]="'Stäng'" [title]="'Visa detaljer'"
  (onClose)="toggleModal()">
  <app-selector #selector [selectorItems]="selectorItems" [selectedItem]="selectedItem"></app-selector>
</zaver-checkout-modal>
